import React from 'react';
import { AssetClassAccordion } from '@/components/portfolio/build/AssetClassAccordion';

interface PortfolioAllocationsGridProps {
  assetClasses: Array<{ id: string; title: string }>;
  getAllocationsForAssetClass: (id: string) => any[];
  portfolioId: string;
  onAssetAdded: () => void;
  portfolioSize: number;
  isPortfolioSizeLocked: boolean;
  onPortfolioSizeChange: (newSize: number) => any;
  selectedIds: Set<string>;
  toggleItem: (id: string) => void;
  toggleAll: (ids: string[]) => void;
  mode: 'percentage' | 'dollar';
  overrides: Record<string, number>;
  onLocalPercentageChange: (id: string, pct: number) => void;
  onLocalDollarChange: (id: string, dollars: number) => void;
  currencyCode: string;
}

export function PortfolioAllocationsGrid(props: PortfolioAllocationsGridProps) {
  return <AssetClassAccordion {...props} />;
}
